import React from "react"
import { Text, TextStyle } from "react-native"

type Props = {
  color: string;
  size: number;
  style: TextStyle | TextStyle[];
}

const Bullet:React.FC<Props> = ({color, size, style}:Props) => {
  return (
    <Text style={{
      color: color,
      fontSize: size,
      padding: 3,
      paddingHorizontal: 6,
      ...style
    }}>{'\u2B24'}</Text>
  )
}

export default Bullet